export default __webpack_public_path__ + "static/media/youtube.aef2a7b0.svg";